export const FILTER_STATUSES = 'statuses';
export const FILTER_OWNERS = 'owners';
export const FILTER_CREATED_BY = 'creators';
export const FILTER_COUNTRIES = 'countries';

export const FILTERS_DEPENDENCIES = {
  [FILTER_OWNERS]: [FILTER_STATUSES],
  [FILTER_CREATED_BY]: [FILTER_STATUSES, FILTER_OWNERS],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_OWNER = 'owner';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_COUNTRY = 'country';
export const COLUMN_UPDATED_DATE = 'lastUpdatedDate';
export const COLUMN_CREATED_DATE = 'createdDate';

export const ACTION_ARCHIVE = 'Deactivate';
export const ACTION_RESTORE = 'Activate';
export const ACTION_DELETE = 'Delete';
export const ACTION_EDIT = 'Edit';

export const STATUS_ACTIVE = 0;
export const STATUS_ARCHIVED = 1;
